import React, { useEffect, useRef, useState } from 'react';
import { useCamera } from '../../hooks/useCamera';

export default function CameraCapture({ onCapture, label = 'Take Photo' }) {
  const { videoRef, isActive, error, startCamera, stopCamera, capturePhoto } = useCamera();
  const [preview, setPreview] = useState(null);
  const [capturing, setCapturing] = useState(false);

  useEffect(() => () => stopCamera(), [stopCamera]);

  async function handleCapture() {
    setCapturing(true);
    const blob = await capturePhoto();
    if (blob) {
      const url = URL.createObjectURL(blob);
      setPreview(url);
      stopCamera();
      onCapture(blob);
    }
    setCapturing(false);
  }

  function handleRetake() {
    setPreview(null);
    startCamera();
    onCapture(null);
  }

  return (
    <div style={{ textAlign: 'center' }}>
      {error && <div className="alert alert-error">{error}</div>}

      {!isActive && !preview && (
        <div style={{ padding: '2rem', background: '#f8fafc', borderRadius: 12, border: '2px dashed #e2e8f0', marginBottom: '1rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>📷</div>
          <p style={{ color: '#64748b', marginBottom: '1rem', fontSize: '0.9rem' }}>
            You must take a live photo to mark attendance
          </p>
          <button className="btn btn-primary" onClick={startCamera} type="button">
            Open Camera
          </button>
        </div>
      )}

      {isActive && (
        <>
          <div className="camera-container" style={{ marginBottom: '1rem' }}>
            <video ref={videoRef} autoPlay playsInline muted className="camera-video" />
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
            <button className="btn btn-secondary" onClick={stopCamera} type="button">Cancel</button>
            <button className="btn btn-success" onClick={handleCapture} disabled={capturing} type="button">
              {capturing ? <><span className="spinner" /> Capturing...</> : `📸 ${label}`}
            </button>
          </div>
        </>
      )}

      {preview && (
        <>
          <img src={preview} alt="Captured" className="photo-preview" style={{ marginBottom: '1rem' }} />
          <div>
            <button className="btn btn-outline btn-sm" onClick={handleRetake} type="button">Retake Photo</button>
          </div>
        </>
      )}
    </div>
  );
}
